import type { IconName } from '@freelancer/ui/icon';

export type EmailProvider = 'gmail' | 'yahoo' | 'outlook';

export interface OpenEmailParams {
  icon: IconName;
  label: string;
  url: string;
}

export const rootEmailDomainToProviderMapping: Record<string, EmailProvider> = {
  freelancer: 'gmail',
  gmail: 'gmail',
  google: 'gmail',
  googlemail: 'gmail',
  yahoo: 'yahoo',
  myyahoo: 'yahoo',
  ymail: 'yahoo',
  outlook: 'outlook',
  live: 'outlook',
  hotmail: 'outlook',
};

export const emailProviderToOpenEmailParams: Record<
  EmailProvider,
  OpenEmailParams
> = {
  gmail: {
    icon: 'flGmail',
    label: $localize`:Open email button label:Open Gmail`,
    url: 'https://mail.google.com/',
  },
  yahoo: {
    icon: 'flMail',
    label: $localize`:Open email button label:Open Yahoo Mail`,
    url: 'https://mail.yahoo.com/',
  },
  outlook: {
    icon: 'flMail',
    label: $localize`:Open email button label:Open Outlook Mail`,
    url: 'https://outlook.live.com/',
  },
};
